import { useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import { Document, Page } from "react-pdf";
import { Props } from "react-pdf/dist/Document";
import useWindowDimensions from "../../hooks/useWindowDimensions";

export interface PdfViewerProps {
    url: string;
    documentProps?: Props;
    maxWidth?: number;
}

export const PdfViewer = (props: PdfViewerProps) => {
    const theme = useTheme();

    const [numPages, setNumPages] = useState<null | number>(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
        setNumPages(numPages);
    }

    const { width, height } = useWindowDimensions();

    return (
        <Box margin={theme.spacing(2)}>
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <Document {...props.documentProps} file={props.url} onLoadSuccess={onDocumentLoadSuccess}>
                    {[...Array((numPages ?? 0) + 1).keys()].slice(1).map((page) => (
                        <Page
                            width={Math.min(
                                Math.min(width * 0.98, props.maxWidth ?? Number.MAX_SAFE_INTEGER, width * 0.98)
                            )}
                            pageNumber={page}
                        />
                    ))}
                </Document>
            </Box>
            {/* <Box sx={{ width: "100%", display: "flex", justifyContent: "center", margin: theme.spacing(1) }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Pagination
                        color="primary"
                        count={numPages ?? 0}
                        onChange={(ev, page) => setPageNumber(page)}
                        showFirstButton
                        showLastButton
                    />
                </Box> 
                    </Box> */}
        </Box>
    );
};
